export default __webpack_public_path__ + "static/media/inbank-logo__purple.6ddd8b3b.svg";